// Rekit uses a new approach to organizing actions and reducers. That is
// putting related actions and reducers in one file. See more at:
// https://medium.com/@nate_wang/a-new-approach-for-managing-redux-actions-91c26ce8b5da

import {
  SIMULADOR_FINANCIERO_CLEAR_MODELS,
} from './constants';

export function clearModels() {
  return {
    type: SIMULADOR_FINANCIERO_CLEAR_MODELS,
  };
}

export function reducer(state, action) {
  if (action.type === SIMULADOR_FINANCIERO_CLEAR_MODELS) {
      return {
        ...state,
        modelos:[],
      };
  }
  else {
      return state;
  }
}
